import styled from 'styled-components'

export const NewValueGreen = styled.span`
  color: var(--theme-colors-theme-positive-darkest);
`

export const NewValueRed = styled.span`
  color: var(--theme-colors-theme-negative-main);
`

export const OldValue = styled.span`
  text-decoration: line-through;
`
